import React, { useEffect, useRef, useState } from "react";

const API_BASE = window.location.hostname === "localhost"
  ? "http://localhost:5000"
  : "";

export default function GlobalAudioPlayer() {
  const audioRef = useRef(null);
  const playAfterTrackChangeRef = useRef(false);
  const [open, setOpen] = useState(false);
  const [tracks, setTracks] = useState([]);
  const [track, setTrack] = useState(
    localStorage.getItem("audio_track") || ""
  );
  const [status, setStatus] = useState("");

  useEffect(() => {
    fetch(`${API_BASE}/api/audio/tracks`)
      .then(response => response.json())
      .then(data => {
        const list = data.tracks || [];
        setTracks(list);
        setTrack(current => current || list[0]?.url || "");
      })
      .catch(() => setStatus("Unable to load audio files"));
  }, []);

  useEffect(() => {
    if (track) {
        localStorage.setItem("audio_track", track);
    }
  }, [track]);

  const rememberPosition = () => {
    if (!audioRef.current) return;
    localStorage.setItem("audio_time", String(audioRef.current.currentTime));
  };

  const restorePosition = () => {
    if (playAfterTrackChangeRef.current) {
      playAfterTrackChangeRef.current = false;
      audioRef.current?.play().catch(() => {
        setStatus("Unable to play the next audio file");
      });
      return;
    }

    const savedTime = Number(localStorage.getItem("audio_time") || 0);
    if (audioRef.current && savedTime) {
      audioRef.current.currentTime = savedTime;
    }
  };

  const playNextTrack = () => {
    if (!tracks.length) return;

    const currentIndex = tracks.findIndex(item => item.url === track);
    const nextIndex = (currentIndex + 1) % tracks.length;

    localStorage.removeItem("audio_time");
    playAfterTrackChangeRef.current = true;
    setTrack(tracks[nextIndex].url);
  };

  return (
    <section className="global-audio-player">
      <button
        type="button"
        className="global-audio-heading"
        onClick={() => setOpen(value => !value)}
      >
        <span>AUDIO PLAYER</span>
        <span>{open ? "CLOSE" : "OPEN"}</span>
      </button>

      {open && (
        <div className="global-audio-content">
          <select value={track} onChange={event => setTrack(event.target.value)}>
            {tracks.map(item => (
              <option key={item.url} value={item.url}>
                {item.name}
              </option>
            ))}
          </select>

          <audio
            ref={audioRef}
            src={track}
            controls
            onLoadedMetadata={restorePosition}
            onTimeUpdate={rememberPosition}
            onEnded={playNextTrack}
          />

          {status && <div>{status}</div>}
          
        </div>
      )}
    </section>
  );
}
